import React from 'react';
import { AccountStatus } from '@/data/mockAccounts';
import { getStatusLabel } from '@/lib/utils';

interface StatusBadgeProps {
  status: AccountStatus;
  size?: 'sm' | 'md';
}

const statusConfig: Record<AccountStatus, { dot: string; bg: string; text: string; icon: string }> = {
  normal: {
    dot: 'bg-green-500',
    bg: 'bg-green-50 text-green-700 border-green-200',
    text: 'text-green-700',
    icon: '✓',
  },
  checking: {
    dot: 'bg-yellow-400',
    bg: 'bg-yellow-50 text-yellow-700 border-yellow-200',
    text: 'text-yellow-700',
    icon: '⟳',
  },
  warning: {
    dot: 'bg-orange-500',
    bg: 'bg-orange-50 text-orange-700 border-orange-200',
    text: 'text-orange-700',
    icon: '⚠',
  },
  unavailable: {
    dot: 'bg-gray-400',
    bg: 'bg-gray-100 text-gray-500 border-gray-200',
    text: 'text-gray-500',
    icon: '✕',
  },
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status];
  const sizeClass = size === 'sm' ? 'text-[11px] px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-pill border font-medium ${config.bg} ${sizeClass}`}
      role="status"
      aria-label={`Trạng thái: ${getStatusLabel(status)}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot} ${status === 'checking' ? 'animate-pulse' : ''}`} aria-hidden="true" />
      {getStatusLabel(status)}
    </span>
  );
}